import clsx from 'clsx';
import styles from './Badge.module.scss';

export type BadgeSize = 'sm' | 'md' | 'lg';

interface BadgeProps {
  children: React.ReactNode;
  size?: BadgeSize;
  tone?:
    | 'default'
    | 'brand'
    | 'brandSecondary'
    | 'fill'
    | 'fillSecondary'
    | 'fillTertiary'
    | 'info'
    | 'success'
    | 'caution'
    | 'critical';
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  size = 'md',
  tone = 'default',
  className,
}) => (
  <span
    className={clsx(styles.badge, className, {
      [styles.sizeSmall]: size === 'sm',
      [styles.sizeMedium]: size === 'md',
      [styles.sizeLarge]: size === 'lg',
      [styles.toneDefault]: tone === 'default',
      [styles.toneBrand]: tone === 'brand',
      [styles.toneBrandSecondary]: tone === 'brandSecondary',
      [styles.toneFill]: tone === 'fill',
      [styles.toneFillSecondary]: tone === 'fillSecondary',
      [styles.toneFillTertiary]: tone === 'fillTertiary',
      [styles.toneInfo]: tone === 'info',
      [styles.toneSuccess]: tone === 'success',
      [styles.toneCaution]: tone === 'caution',
      [styles.toneCritical]: tone === 'critical',
    })}
  >
    {children}
  </span>
);
